<template>
  <div class="row m-0 requestlistdetail">
    <div class="row m-0 h-100 justify-content-center align-items-center" v-if="isLoading">
      <b-spinner  variant="secondary"/>
    </div>
    <div v-else class="requestlistdetail__tab">
      <div class="requestlistdetail__tab--icon mb-2"
        :class="[{'icon-selected' : item.name === tabSelected}, item.name === tabSelected ? 'global__bc_blue' : '', 'hover__blue']"
        :id="`msdetail-icon-${i}`" @click="chooseTab(item)"
        v-for="(item, i) in tablist" :key="i">
        <img :src="item.image" alt="">
        <b-tooltip :id="custDetail && 'tabs_detail'"
        :target="`msdetail-icon-${i}`"
          :delay="{ show: 400, hide: 50 }" placement="righttop">
          {{ item.name }}
        </b-tooltip>
      </div>
    </div>
    <keep-alive>
        <component
          :is="componentSelected"
          :custDetail="custDetail"
          :canEdit="canEdit"
          @chooseEdit="chooseEdit"
        >
        </component>
    </keep-alive>

  </div>
</template>

<script>
import mixin from '@/mixin/getters/shipment-details'

import AddressDetails from './tabs-detail/AddressDetails.vue'
import ShipmentType from './tabs-detail/ShipmentType.vue'
import ProductDetails from './tabs-detail/ProductDetails.vue'
import Others from './tabs-detail/Others.vue'

export default {
  name: 'DetailsAirOcean',
  props: {
    typeRequest: String,
    custDetail: Object,
    isLoading: Boolean
  },
  components: {
    AddressDetails,
    ShipmentType,
    ProductDetails,
    Others
  },
  mixins: [mixin],
  created () {
    this.$eventHub.$on('catch-confrim-edit-MS', this.catchConfirmEdit)
  },
  beforeDestroy () {
    this.$eventHub.$off('catch-confrim-edit-MS')
  },
  data () {
    return {
      tabIndex: 0,
      canEdit: false,
      componentSelected: AddressDetails,
      currentChooseSection: '',
      tabSelected: 'Shipping Details Address',
      tablist: [
        {
          name: 'Shipping Details Address',
          image: require('@/assets/image/icon/details_address.svg'),
          component: AddressDetails
        },
        {
          name: 'Shipment Type',
          image: require('@/assets/image/icon/shipment_type.svg'),
          component: ShipmentType
        },
        {
          name: 'Product Details',
          image: require('@/assets/image/icon/product_details.svg'),
          component: ProductDetails
        },
        {
          name: 'Others',
          image: require('@/assets/image/icon/others.svg'),
          component: Others
        }
      ]
    }
  },
  methods: {
    chooseEdit (data) {
      this.canEdit = data
    },
    chooseTab (item) {
      this.currentChooseSection = item
      if (!this.canEdit && (this.tabSelected !== item.name)) {
        this.tabSelected = item.name
        this.componentSelected = item.component
      } else if (this.canEdit && (this.tabSelected !== item.name)) {
        this.$eventHub.$emit('dialog-confirm-edit-ms')
      }
    },
    catchConfirmEdit (leaving) {
      if (leaving) {
        this.canEdit = false
        this.$eventHub.$emit('reset-data')
        this.chooseTab(this.currentChooseSection)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/requestList/detail-instant-quote/Details.vue